module.exports = __webpack_public_path__ + "img/vk.7b34992f.svg";